import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ExportColumn, ExportRow } from "../../types/ExportTypes";
import { getNestedValue } from "../getNestedValue";

export function exportXLSX(
  columns: ExportColumn[],
  data: ExportRow[],
  filename: string = "export.xlsx"
): void {
  const excelData = data.map((row) => {
    const newObj: Record<string, any> = {};
    columns.forEach((col) => {
      const value = getNestedValue(row, col.key);
      if (col.key === "ativo") {
        newObj[col.label] = value ? "Ativo" : "Inativo";
      } else {
        newObj[col.label] = value;
      }
    });
    return newObj;
  });

  const worksheet = XLSX.utils.json_to_sheet(excelData);

  worksheet["!cols"] = columns.map(() => ({ wch: 25 }));

  // header estilos básicos
  columns.forEach((col, index) => {
    const addr = XLSX.utils.encode_cell({ r: 0, c: index });
    const cell = worksheet[addr];
    if (cell) {
      cell.s = {
        font: { bold: true },
        alignment: { horizontal: "center" },
      };
    }
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Dados");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(blob, filename);
}
